import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";

export const BenefitsSection = () => {
  const benefits = [
    "Faster lead conversion through AI agent qualification",
    "Enhanced team productivity with automated workflows",
    "Data-driven insights for strategic decision-making",
    "Improved customer experience through personalization",
    "Seamless integration with existing CRM systems",
    "Real-time performance tracking and optimization"
  ];

  return (
    <section className="py-20 bg-blue-50">
      <div className="max-w-7xl mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Benefits of AI-Powered Lead Generation
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Transform your sales process with cutting-edge AI technology
          </p>
        </motion.div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="flex items-start gap-4 bg-white p-6 rounded-lg shadow-md"
            >
              <CheckCircle2 className="h-6 w-6 text-green-500 flex-shrink-0 mt-1" />
              <p className="text-gray-700">{benefit}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
